module.exports = __webpack_public_path__ + "static/media/parodydavidblaine.aa862f77.gif";